import { Modal } from "src/components";
import { translate } from "src/services";
import {
  Button,
  ModalSection,
  ModalTitle,
  Separator,
  TextDisplay,
  Wrapper,
} from "src/styled";

interface Props {
  closeModal: () => void;
  onCancelRequest: () => void;
}

const CancelRequestItemsModal = ({ closeModal, onCancelRequest }: Props) => {
  return (
    <Modal size="small" onClose={closeModal} padding="medium" title="">
      <>
        <Wrapper margin="no auto" maxWidth={400}>
          <ModalSection>
            <Separator height={50} />
            <ModalTitle fontSize="32px">
              <b> {translate("wizardPage.cancelRequestModalTitle")}</b>
            </ModalTitle>
            <Separator height={50} />
            <TextDisplay block margin="medium small">
              {translate("wizardPage.cancelRequestModalContent1")}
            </TextDisplay>
            <TextDisplay block margin="medium small">
              {translate("wizardPage.cancelRequestModalContent2")}
            </TextDisplay>
            <TextDisplay block margin="medium small">
              {translate("wizardPage.cancelRequestModalContent3")}
            </TextDisplay>
          </ModalSection>
          <Separator height={50} />
          <ModalSection>
            <Wrapper textAlign="center">
              <Button onClick={onCancelRequest} color="alert" margin="no small">
                {translate("wizardPage.confirmCancelation")}
              </Button>
              <Button onClick={closeModal} color="primary" margin="no small">
                {translate("wizardPage.keepRequest")}
              </Button>
            </Wrapper>
          </ModalSection>
          <Separator height={20} />
        </Wrapper>
      </>
    </Modal>
  );
};

export default CancelRequestItemsModal;
